import React, {ReactNode} from "react";
import PageAncestor from "core/common/page/pageAncestor";
import mdEntityService from "core/metamodel/mdEntityService";
import {MODULE, PageProps, PERMISSION} from "core/metamodel/metaConstant";
import {observer} from "mobx-react";
import {action, ObservableMap} from "mobx";
import MdEntity from "core/metamodel/mdEntity";
import {loc} from "core/common/config/locales";
import 'flag-icon-css/css/flag-icon.css';
import {Project} from "../../domain/project/projectDomain";
import SbToolProjectService from "../../service/projectService"
import gridService from "../../../core/grid/gridService";
import Grid, {GridLocation} from "../../../core/grid/domain/grid";
import {MovingBlocks} from "../../../core/grid/gridUtils";
import GridComp, {UILOCATION} from "../../../core/grid/component/gridComp";
import {MdBlockArray} from "../../../core/components/blockComp/blockComp";
import SbToolProjectForm from "../../component/projectForm";
import {SecuredZzUploadFlatButton, ZzFlatButton, ZzFlatButtonRoute} from "../../../core/components/buttons/buttons";
import uiService from "../../../core/common/service/uiService";
import {IDomainObject, preSave} from "../../../core/form/formUtils";
import Toolmenu from "../../../core/components/toolmenu/toolmenu";
import {PAGE} from "../../../routes";
import {PROJECT_VERSIONS_LIST} from "../../gridsContants";
import {PROJECT_ENTITY} from "../../entityConstants";
import ConfirmationDialog from "../../../core/components/confirmationDialog/confirmationDialog";


@observer
export default class ProjectDetail extends PageAncestor<PageProps, undefined> {

  static module = MODULE.sbtool;
  static title = loc.i18n`Project`;
  static icon = 'building-o';
  static protectedPage = true;

  private onDeletePopUp : ConfirmationDialog

  static fetchData(routerParams, query) {
    console.log("sbToolProjectDetails#fetchData(%O)", query);

    let metadataPromise = mdEntityService.fetchEntityMetadata([PROJECT_ENTITY]);

    let projectPromise: Promise<Project>;


    if (routerParams.id === 'new') {
      projectPromise = Promise.resolve(new Project(Object.assign({$new: true, active: true}, query)));
    } else {
      projectPromise = SbToolProjectService.readProject(routerParams.id)
    }

    let gridPromise = gridService.fetchGrids(PROJECT_VERSIONS_LIST)


    return Promise.all([metadataPromise, projectPromise, gridPromise])
      .then(([entityMap, sbToolProjectObject, gridLocationMap]: [ObservableMap<MdEntity>, Project, ObservableMap<GridLocation>]) => {
        SbToolProjectService.projectObject = sbToolProjectObject;
        SbToolProjectService.projectObject.$movingBlocks = new MovingBlocks(PROJECT_VERSIONS_LIST, true, query.tab,
          new Grid(gridLocationMap.get(PROJECT_VERSIONS_LIST), SbToolProjectService.projectObject.projectId),
        );
        SbToolProjectService.projectObject = sbToolProjectObject.initAfterRead(routerParams.id === 'new');
      })
  }


  componentDidUpdate(prevProps: PageProps) {
    if (this.idChanged(prevProps.params.id, this.props.params.id)) {
      SbToolProjectService.projectObject.$movingBlocks.searchExposedGrids(SbToolProjectService.projectObject);
    }
  }

  componentDidMount() {
    console.debug("%c componentDidMount", "background-color: magenta");
    SbToolProjectService.projectObject.$movingBlocks.searchExposedGrids(SbToolProjectService.projectObject);
    console.log('project id', SbToolProjectService.projectObject.projectId)
  }

  componentWillUnmount() {
    SbToolProjectService.projectObject = null;
  }

  findRootObject() {
    return SbToolProjectService.projectObject;
  }

  @action onSave = (evt) => {
    // console.log('onSave ');
    uiService.showToolbarActionFlag();

    let result = preSave(SbToolProjectService.projectObject);
    if (!result) {
      return;
    }

    let wasNew: boolean;

    return SbToolProjectService.saveProject(SbToolProjectService.projectObject)
      .then(action("sbToolProjectSave-callback", (productJson: IDomainObject) => {
        wasNew = SbToolProjectService.projectObject.cleanAfterSave(productJson);
      })).then(x => {
        if (wasNew) {
          this.context.router.replaceWith('sbToolProjectDetail', {id: SbToolProjectService.projectObject.projectId});
           window.location.reload(); // TODO : REMOVE IT
        }
        uiService.hideToolbarActionFlag();
      }).catch(error => {
        SbToolProjectService.projectObject.$errors = error.getMessages();
      });

  };

  @action onDelete = () => {
    // console.log('onDelete');
    let project: Project = SbToolProjectService.projectObject;

    uiService.showToolbarActionFlag();

    SbToolProjectService.deleteProject(project.projectId)
      .then(() => {
        uiService.hideToolbarActionFlag();
        this.context.router.transitionTo("sbToolProjectsList");
      }, error => {
        project.$errors = error.getMessages();
      });
  };

  private renderMainForm = (): ReactNode => {
    let propsForCreateForm = {
      dataObject: SbToolProjectService.projectObject,
      rootObject: SbToolProjectService.projectObject,
      entity: mdEntityService.getEntity(PROJECT_ENTITY),
      entities: mdEntityService.entityMap
    };

    return (
      <form style={{marginTop: 10}}>
        <h6 style={{padding:10,textTransform:"uppercase", textAlign:'center',backgroundColor:'rgb(236, 239, 241)'}}>
          TP01_Identifikace
        </h6>

        <MdBlockArray inset>
          {[
            <SbToolProjectForm {...propsForCreateForm} key={1}/>,
          ]}
        </MdBlockArray>
      </form>
    );
  }


  renderVersions = (): ReactNode => {
    let project: Project = SbToolProjectService.projectObject
    if (project.$new) {
      return <noscript/>
    }
    let versionsGrid: Grid = project.$movingBlocks.getBlock(PROJECT_VERSIONS_LIST) as Grid;


    return (
      <GridComp grid={versionsGrid} uiLocation={UILOCATION.tab} entities={mdEntityService.entityMap} hideGridConfig
                hideCopyRow key={1}>
        <ZzFlatButtonRoute onGridToolbar routeName="sbToolProjectVersionDetail" params={{id: 'new'}}
                           query={{projectId: project.projectId}} label={loc.i18n`New project version`}
                           permission={PERMISSION.New} securable={PAGE.sbToolProjectVersionDetail}/>
      </GridComp>)
  }

handleDeleteProject=()=> {
    this.onDeletePopUp.open(()=> {
      this.onDelete()
    },
      cancel=> {
      return
      },
      "Chcete projekt vymazat? (Tuto akci nelze zastavit. Data budou trvale vymazána)")
}
  private renderToolTipMenu = (): ReactNode => {
    let {query} = this.props;
    let project: Project = SbToolProjectService.projectObject;
    return (
      <Toolmenu chainGridLocation={query.gridLocation} backAction={()=> {
        this.context.router.transitionTo("sbToolProjectsList");
        window.location.reload()
      }}
                activeTab={project.$movingBlocks.activeBlockTab}>
        <ZzFlatButton onClick={this.onSave} disabled={!project.$dirty} label={loc.i18n`Save`}
                      permission={project.$new ? PERMISSION.New : PERMISSION.Update}/>
        <ZzFlatButton onClick={this.handleDeleteProject} disabled={project.$new} label={loc.i18n`Delete`} permission={PERMISSION.Delete}/>
      </Toolmenu>
    );
  }

  submitDeleteDialogRefHandler = comp => this.onDeletePopUp = comp;

  render() {
    return (
      <main className="main-content" style={{display: 'flex', flexDirection: 'column', padding: 20}}>
        <ConfirmationDialog ref={this.submitDeleteDialogRefHandler}/>

        <div>
          {this.renderToolTipMenu()}
          {this.renderMainForm()}
        </div>
        {this.renderVersions()}
      </main>
    );
  }


}




// WEBPACK FOOTER //
// ./src/sbtool/page/project/projectDetail.tsx